import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import Home from "./Components/Home";
import Sidenav from "./Components/Sidenav";
import Header from "./Components/Header";
import Changepass from "./Pages/Changepass";
import Login from "./Pages/Login";
import { useState, useEffect } from "react";
import Adminormonitors from "./Pages/adminormonitors";
import Addrecord from "./Components/Addrecord";
import Editrecord from "./Components/Editrecord";
import Viewrecord from "./Components/Viewrecord";
import Smsgateways from "./Pages/Smsgateways";
import Allowip from "./Pages/Allowip";
import Smsgatewaysaddrecord from "./Components/Smsgatewaysaddrecord";
import Updatesmsgateways from "./Components/Updatesmsgateways";
import Viewsmsgateways from "./Components/Viewsmsgateways";
import Smtpgateways from "./Pages/Smtpgateways";
import Addsmtpgateways from "./Components/Addsmtpgateways";
import Viewsmtpgateways from "./Components/Viewsmtpgateways";
import Updatesmtpgateway from "./Components/Updatesmtpgateway";
import ProtectedRoute from "./Components/ProtectedRoute";
import SmsCampaigns from "./Pages/Smscampaign";
import Addsmscampaigns from "./Components/Addsmscampaigns";
import Updatesmscampaign from "./Components/Updatesmscampaign";
import Viewsmscampaigns from "./Components/Viewsmscampaigns";
import Addsmscampaignlist from "./Components/Addsmscampaignlist";
import Viewsmscampaignlist from "./Components/Viewsmscampaignlist";
import Updatesmscampaignlist from "./Components/Updatesmscampaignlist";
import Addsmscampaignlistretry from "./Components/Addsmscampaignlistretry";
import Viewsmscampaignshortcuts from "./Components/Viewsmscampaignshortcuts";
import SmscampaignReportsList from "./Pages/SmscampaignReports";
import Viewsmscampaignreports from "./Components/Viewsmscampaignreports";
import Smtpcampaign from "./Pages/Smtpcampaign";
import Addsmtpcampaigns from "./Components/Addsmtpcampaign";
import Updatesmtpcampaign from "./Components/Updatesmtpcampaign";
import Viewsmtpcampaign from "./Components/Viewsmtpcampaign";
import SmtpcampaignReportsList from "./Pages/Smtpcampaignreports";
import Viewsmtpcampaignreports from "./Components/Viewsmtpcampaignreports";
import Checkbalance from "./Pages/Checkbalance";
import UserLogin from "./User/Pages/Login";
import NotFound from "./Pages/NotFound";
import UserLayout from "./User/Layout";
import UserLogged from "./Middlewares/UserLogged";
import UserProtectedRoute from "./Middlewares/UserProtectedRoute";
import Dashboard from "./User/Pages/Dashboard";
import CampaignList from "./User/Pages/Chatbox/CampaignList";
import ChatBox from "./User/Pages/Chatbox/ChatBox";
import { useRole } from "./User/store";
import MonitorDashboard from "./User/Pages/Monitor/Dashboard";
import SmsCampaignWiseReports from "./Pages/Reports/Smscampaignwisereports.tsx";
import SmsCampaignWiseReportsList from "./Pages/Reports/Smscampaignwisereports.tsx";
import Viewsmscampaignwisereports from "./Components/Viewsmscampaignwisereports";
import Duplicatenumbers from "./Pages/Reports/Duplicatenumberreports.tsx";
import Userlogsreports from "./Pages/Reports/Userlogsreports";
import AgentWiseReport from "./User/Pages/Reports/AgentWiseReport";
import HistroyReport from "./User/Pages/Reports/History";
import SMSConversionReport from "./User/Pages/Reports/SMSConversionReport";
import Flagkeyword from "./Pages/Flagkeyword";
import Addflagkeyword from "./Components/Addflagkeyword";
import UpdateFlagkeyword from "./Components/UpdateFlagkeyword";
import Blocklist from "./Pages/Blocklist";
import OneToOneCampaignList from "./Pages/Reports/OneToOneReport/CampaignList";
import OneToOneReport from "./Pages/Reports/OneToOneReport/Report";
import ReportCampaignList from "./User/Pages/Reports/CampaignList";
import UserOneToOneReport from "./User/Pages/Reports/MonitorOneToOneReport";
import MonitorCampaignWiseReport from "./User/Pages/Reports/MonitorCampaignWiseReport";
import CustomReport from "./Pages/Reports/CustomReport";
import MonitorCustomReport from "./User/Pages/Reports/MonitorCustomReport";
import MonitorCustomerWiseReport from "./User/Pages/Reports/CustomerWiseReport";
import MonitorIncomingAndOutgoingReport from "./User/Pages/Reports/IncomingAndOutgoingReport";
import MonitorDayWiseReport from "./User/Pages/Reports/DayWiseReport";
import MonitorAgentWiseDayMonthReport from "./User/Pages/Reports/AgentDateMonthWiseReport";
import MonitorDispositionStatusReports from "./User/Pages/Reports/MonitorDispositionStatusReports";
import MonitorDispositionStatusReportsView from "./User/Pages/Reports/MonitorDispositionStatusReportsView";
import AgentList from "./User/Pages/Reports/AgentList";
import AgentPinChat from "./User/Pages/Reports/AgentPinChat";
import SMSConversionReportV2 from "./User/Pages/Reports/SMSConversionReport/V2";

function App() {
  const isMonitor = useRole((state) => state?.isMonitor);
  const isFetching = useRole((state) => state?.isFetching);
  const checkIsMonitor = useRole((state) => state?.checkIsMonitor);
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("token") ? true : false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(token ? true : false);
    if (localStorage.getItem("user_token")) checkIsMonitor();
    // eslint-disable-next-line
  }, []);

  return (
    <Router>
      <Routes>
        {/* User Routes */}
        <Route
          path="login"
          element={<UserLogged><UserLogin /></UserLogged>} />

        <Route
          element={
            <div className="wrapper">
              <UserProtectedRoute>
                <UserLayout />
              </UserProtectedRoute>
            </div>
          }
        >
          {isMonitor || isFetching ? (
            <>
              {/* <Route path="monitor-dashboard" element={<MonitorDashboard />} /> */}
              <Route path="report/agent-wise" element={<AgentWiseReport />} />
              <Route path="report/sms-conversion" element={<SMSConversionReport />} />
              <Route
                path="report/campaign-wise/campaign-list"
                element={<ReportCampaignList RedirectURL="/report/campaign-wise" ReportTitle="Campaign Wise Report" />} />
              <Route path="report/campaign-wise" element={<MonitorCampaignWiseReport />} />
              <Route path="report/custom" element={<MonitorCustomReport />} />
              <Route path="report/customer-wise" element={<MonitorCustomerWiseReport />} />
              <Route path="report/customer-wise/campaign-list" element={<ReportCampaignList RedirectURL="/report/customer-wise" ReportTitle="Customer Wise Report" />} />

              <Route path="report/incoming-outgoing" element={<MonitorIncomingAndOutgoingReport />} />
              <Route path="report/incoming-outgoing/campaign-list" element={<ReportCampaignList RedirectURL="/report/incoming-outgoing" ReportTitle="Incoming & Outgoing Report" />} />

              <Route path="report/day-wise" element={<MonitorDayWiseReport />} />
              <Route path="report/day-wise/campaign-list" element={<ReportCampaignList RedirectURL="/report/day-wise" ReportTitle="Day Wise Report" />} />

              <Route path="report/agent-wise-day-month" element={<MonitorAgentWiseDayMonthReport />} />
              <Route path="report/agent-wise-day-month/campaign-list" element={<ReportCampaignList RedirectURL="/report/agent-wise-day-month" ReportTitle="Agent Wise (D-W-M) Report" />} />

              <Route path="report/disposition-status" element={<MonitorDispositionStatusReports />} />
              <Route path="report/disposition-status/campaign-list" element={<ReportCampaignList RedirectURL="/report/disposition-status" ReportTitle="Disposition Report" />} />
              {/* <Route path="report/sms-conversion-report/campaign-list" element={<ReportCampaignList RedirectURL="/report/sms-conversion-report/agent-list" ReportTitle="SMS Conversion Report - 2" />} /> */}
              <Route path="/report/sms-conversion-report/agent-list" element={<AgentList />} />
              <Route path="/report/sms-conversion-report/agent/pin-chats" element={<AgentPinChat />} />
              <Route path="/report/disposition-status/view/:id" element={<MonitorDispositionStatusReportsView />} />
              <Route path="/report/sms-conversion-report/chats" element={<SMSConversionReportV2 />} />
            </>
          ) :
            <>
              <Route path="monitor-dashboard" element={<Navigate to="/" />} />
              <Route path="report/agent-wise" element={<Navigate to="/" />} />
              <Route path="report/sms-conversion" element={<Navigate to="/" />} />
              <Route path="report/campaign-wise/campaign-list" element={<Navigate to="/" />} />
              <Route path="report/custom" element={<Navigate to="/" />} />
              <Route path="report/campaign-wise" element={<Navigate to="/" />} />
              <Route path="report/customer-wise" element={<Navigate to="/" />} />
              <Route path="report/customer-wise/campaign-list" element={<Navigate to="/" />} />
              <Route path="report/incoming-outgoing" element={<Navigate to="/" />} />
              <Route path="report/incoming-outgoing/campaign-list" element={<Navigate to="/" />} />
              <Route path="report/day-wise" element={<Navigate to="/" />} />
              <Route path="report/day-wise/campaign-list" element={<Navigate to="/" />} />
              <Route path="report/agent-wise-day-month" element={<Navigate to="/" />} />
              <Route path="report/agent-wise-day-month/campaign-list" element={<Navigate to="/" />} />
              {/* <Route path="report/sms-conversion-report/campaign-list" element={<Navigate to="/" />} /> */}
              <Route path="/report/sms-conversion-report/agent-list" element={<Navigate to="/" />} />
              <Route path="/report/sms-conversion-report/agent/pin-chats" element={<Navigate to="/" />} />
              <Route path="/report/sms-conversion-report/chats" element={<Navigate to={"/"} />} />
            </>}
          <Route path="report/history" element={<HistroyReport />} />
          <Route path="report/one-to-one/campaign-list" element={<ReportCampaignList RedirectURL="/report/one-to-one" ReportTitle="One To One Report" />} />
          <Route path="report/one-to-one" element={<UserOneToOneReport />} />

          <Route path="/" element={isMonitor ? <MonitorDashboard /> : isFetching ? <></> : <Dashboard />} />
          <Route path="/chat-box" element={<ChatBox />} />
          <Route path="/chat-box/campaigns" element={<CampaignList />} />
        </Route>
        {/* User Routes */}

        {/* Public route for login */}
        <Route
          path="/admin/login"
          element={<Login setIsLoggedIn={setIsLoggedIn} />}
        />

        {/* Protected routes */}
        <Route element={<ProtectedRoute isLoggedIn={isLoggedIn} />}>
          <Route
            element={
              <div className="wrapper">
                <Header />
                <Sidenav />
                <Outlet />
              </div>
            }
          >
            {/* These routes will only be accessible when the user is logged in */}
            <Route path="/admin/dashboard" element={<Home />} />
            <Route path="/admin" element={<Navigate to={"/admin/dashboard"} />} />

            {/* Admin Routes */}
            <Route path="/admin/users" element={<Adminormonitors />} />
            <Route path="/admin/users/add" element={<Addrecord />} />
            <Route path="/admin/users/update/:id" element={<Editrecord />} />
            <Route path="/admin/users/view/:id" element={<Viewrecord />} />

            {/* SMS Gateways */}
            <Route path="/admin/smsgateways" element={<Smsgateways />} />
            <Route
              path="/admin/smsgateways/add"
              element={<Smsgatewaysaddrecord />}
            />
            <Route
              path="/admin/smsgateways/update/:id"
              element={<Updatesmsgateways />}
            />
            <Route
              path="/admin/smsgateways/view/:id"
              element={<Viewsmsgateways />}
            />

            {/* SMTP Gateways */}
            <Route path="/admin/smtp-gateways" element={<Smtpgateways />} />
            <Route
              path="/admin/smtp-gateways/add"
              element={<Addsmtpgateways />}
            />
            <Route
              path="/admin/smtp-gateways/update/:id"
              element={<Updatesmtpgateway />}
            />
            <Route
              path="/admin/smtp-gateways/view/:id"
              element={<Viewsmtpgateways />}
            />

            {/* =======Sms-Campaign-Start============ */}
            {/*SMS-Campaign */}
            <Route path="/admin/sms-campaigns" element={<SmsCampaigns />} />
            <Route
              path="/admin/sms-campaigns/add"
              element={<Addsmscampaigns />}
            />
            <Route
              path="/admin/sms-campaigns/update/:id"
              element={<Updatesmscampaign />}
            />
            <Route
              path="/admin/sms-campaigns/view/:id"
              element={<Viewsmscampaigns />}
            />

            {/*SMS-Campaign-List */}
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-list/:id/*"
              element={<Viewsmscampaigns />}
            />
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-list/add/:id"
              element={<Addsmscampaignlist />}
            />
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-list/view/:id"
              element={<Viewsmscampaignlist />}
            />
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-list/update/:id"
              element={<Updatesmscampaignlist />}
            />
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-list/retry"
              element={<Addsmscampaignlistretry />}
            />
            <Route
              path="/admin/sms-campaigns/update/:id"
              element={<Updatesmscampaign />}
            />
            <Route
              path="/admin/sms-campaigns/view/:id"
              element={<Viewsmscampaigns />}
            />

            {/*Sms-Campaign-Shortcuts */}
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-shortcuts/:id/*"
              element={<Viewsmscampaigns />}
            />
            <Route
              path="/admin/sms-campaigns/view/sms-campaigns-shortcuts/view/:id/*"
              element={<Viewsmscampaignshortcuts />}
            />
            {/* =======Sms-Campaign-End============ */}

            {/* =======Smtp-Campaign-Start============ */}
            {/* Smtp-Campaign */}
            <Route path="/admin/smtp-campaigns" element={<Smtpcampaign />} />
            <Route
              path="/admin/smtp-campaigns/add"
              element={<Addsmtpcampaigns />}
            />
            <Route
              path="/admin/smtp-campaigns/update/:id"
              element={<Updatesmtpcampaign />}
            />
            <Route
              path="/admin/smtp-campaigns/view/:id"
              element={<Viewsmtpcampaign />}
            />
            {/* =======Smtp-Campaign-Start============ */}


            {/* =========Flag-keyword-start========= */}
            <Route path="/admin/flag-keyword" element={<Flagkeyword />} />
            <Route path="/admin/flag-keyword/add" element={<Addflagkeyword />} />
            <Route path="/admin/flag-keyword/update/:id" element={<UpdateFlagkeyword />} />
            {/* =========Flag-keyword-end========= */}

            {/* =========Block-list-start============ */}
            <Route path="/admin/block-list" element={<Blocklist />} />
            {/* =========Block-list-end============ */}


            {/* Reports */}
            <Route
              path="/admin/sms-campaign-reports/list"
              element={<SmscampaignReportsList />}
            />
            <Route
              path="/admin/sms-campaign-reports/:id"
              element={<Viewsmscampaignreports />}
            />
            <Route
              path="/admin/smtp-campaign-reports/list"
              element={<SmtpcampaignReportsList />}
            />
            <Route
              path="/admin/smtp-campaign-reports/:id"
              element={<Viewsmtpcampaignreports />}
            />


            <Route
              path="/admin/sms-campaign-wise-reports/list"
              element={<SmsCampaignWiseReportsList />}
            />
            <Route
              path="/admin/sms-campaign-wise-reports/:id"
              element={<Viewsmscampaignwisereports />}
            />

            {/* One To One Report */}
            <Route
              path="/admin/one-to-one-report/campaign"
              element={<OneToOneCampaignList />}
            />
            <Route
              path="/admin/one-to-one-report/:id"
              element={<OneToOneReport />}
            />
            {/* One To One Report */}

            {/* Admin Custom Report */}
            <Route
              path="/admin/custom/report"
              element={<CustomReport />}
            />
            {/* Admin Custom Report */}

            <Route
              path="/admin/duplicate-numbers-reports"
              element={<Duplicatenumbers />}
            />
            <Route
              path="/admin/user-logs-reports"
              element={<Userlogsreports />}
            />

            <Route
              path="/admin/sms-campaigns/view/:id/*"
              element={<Viewsmscampaigns />}
            />

            {/* Change Password */}
            <Route path="/admin/change-password" element={<Changepass />} />

            {/* Allow IP */}
            <Route path="/allowip" element={<Allowip />} />

            {/* Check balance */}
            <Route path="/admin/check-balance" element={<Checkbalance />} />
          </Route>
        </Route>

        {/* Redirect all other paths to login if not authenticated */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
